import { call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import { push } from 'connected-react-router'
import { showSpinner, hideSpinner } from '../actions/loading.actions';
import {
    REQUEST_LOGIN,
    REQUEST_REGISTER,
    REQUEST_LOGIN_GUEST,
    LOGIN_API_GOOGLE,
    LOGIN_API_FACEBOOK, REFRESH_TOKEN_AUTH,
    SEND_TEMPORARY_PASSWORD, 
    RESET_PASSWORD,
    CHANGE_PASSWORD
} from "../actions/types";
import {login, register, loginGuest, loginFacebook, loginGoogle, refreshTokenLogin, sendTemporaryPassword, resetPassword, changePassword} from '../api/user.api';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import {
    loginSucceeded,
    registerSucceeded,
    loginApiMessagesShow,
    registerApiMessagesShow, loginSucceededGuest, requestLoginGuest
} from '../actions/user.actions';
import {
    WRONG_LOGIN_CREDENTIALS,
    GENERIC_ERROR_MESSAGE,
    WRONG_PASSWORD,
    CHANGE_PASSWORD_SUCCEEDED_MESSAGE,
    USER_ALREADY_EXISTS,
    WRONG_TEMPORARY_PASSWORD
} from "../config/messages";
import {LOGIN_ROUTE, ROOT_ROUTE} from "../config/routes";
import {getUserDetails, getUnviewedNotificationCount} from "../api/profile.api";
import {
    getUnviewedNotificationsCountSucceeded,
    getUserDetailsSucceeded
} from "../actions/profile.actions";
import { redirectUrlSucceeded } from '../actions/filters.actions';


function* loginSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(login, action.payload);
        if (response.data.access_token) {
            yield put(hideSpinner());
            //set in localStorage the access token and the login_type
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('login_type', response.data.user_roles[0]);
            localStorage.setItem('refresh_token', response.data.refresh_token);
            localStorage.setItem('user_id', response.data.user_id);
            const location = yield select(state => state.filters.selectedCinemaLocation);
            localStorage.setItem('cinema_location', location);
            let today = new Date();
            today.setSeconds(today.getSeconds() + response.data.expires_in);
            let datePlus = today.getTime();
            localStorage.setItem('expires_in', datePlus);

            //bring user details from a separate call
            yield put(showSpinner());
            const details = yield call(getUserDetails, response.data.user_id);
            if (details.status === 200){
                yield put(hideSpinner());
                yield put(getUserDetailsSucceeded(details.data));
            }
            

            //get notifications
            yield put(showSpinner());
            const notifications = yield call(getUnviewedNotificationCount);
            if (notifications.status === 200){
                yield put(hideSpinner());
                yield put(getUnviewedNotificationsCountSucceeded(notifications.data));
            }

            //set in Redux state the access token
            yield put(loginSucceeded(response.data));
            const redirectUrl = yield select(state => state.filters.redirectUrl);
            if (redirectUrl){
                yield put(push(redirectUrl));
                yield put(redirectUrlSucceeded(""));
            } else {
                yield put(push(ROOT_ROUTE));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        if( e.message.substr(e.message.length - 3) === '401') {
            yield put(loginApiMessagesShow(WRONG_LOGIN_CREDENTIALS));
            yield call(delay, 5000);
            yield put(loginApiMessagesShow(""));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }

    }
}

function* loginGuestSaga(action) {
    try {
        const response = yield call(loginGuest, action.payload);
        if(response.data.access_token) {
            //set in localStorage the access token and the login type
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('login_type', response.data.user_roles[0]);
            localStorage.setItem('cinema_location', "Bucuresti");
            //set in Redux state the access token
            yield put(loginSucceededGuest(response.data));
        }

    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* loginFacebookSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(loginFacebook, action.payload);
        if (response.data.access_token) {
            yield put(hideSpinner());
            //set in localStorage the access token and the login_type
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('login_type', response.data.user_roles[0]);
            localStorage.setItem('refresh_token', response.data.refresh_token);
            localStorage.setItem('expires_in', response.data.expires_in);
            localStorage.setItem('user_id', response.data.user_id);
            localStorage.setItem('cinema_location', "Bucuresti");
            let today = new Date();
            today.setSeconds(today.getSeconds() + response.data.expires_in);
            let datePlus = today.getTime();
            localStorage.setItem('expires_in', datePlus);

            //bring user details from a separate call
            yield put(showSpinner());
            const details = yield call(getUserDetails, response.data.user_id);
            if (details.status === 200) {
                yield put(hideSpinner());
                yield put(getUserDetailsSucceeded(details.data));
            }

            //get notifications
            yield put(showSpinner());
            const notifications = yield call(getUnviewedNotificationCount);
            if (notifications.status === 200) {
                yield put(hideSpinner());
                yield put(getUnviewedNotificationsCountSucceeded(notifications.data));
            }

            //set in Redux state the access token
            yield put(loginSucceeded(response.data));
            yield put(push(ROOT_ROUTE))
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* loginGoogleSaga(action) {

    try {
        yield put(showSpinner());
        const response = yield call(loginGoogle, action.payload);

        if (response.data.access_token) {
            yield put(hideSpinner());
            //set in localStorage the access token and the login_type
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('login_type', response.data.user_roles[0]);
            localStorage.setItem('refresh_token', response.data.refresh_token);
            localStorage.setItem('expires_in', response.data.expires_in);
            localStorage.setItem('user_id', response.data.user_id);
            localStorage.setItem('cinema_location', "Bucuresti");
            let today = new Date();
            today.setSeconds(today.getSeconds() + response.data.expires_in);
            let datePlus = today.getTime();
            localStorage.setItem('expires_in', datePlus);

             //bring user details from a separate call
             yield put(showSpinner());
             const details = yield call(getUserDetails, response.data.user_id);
             if (details.status === 200) {
                yield put(hideSpinner());
                yield put(getUserDetailsSucceeded(details.data));
             }
 
             //get notifications
             yield put(showSpinner());
             const notifications = yield call(getUnviewedNotificationCount);
             if (notifications.status === 200) {
                yield put(hideSpinner());
                yield put(getUnviewedNotificationsCountSucceeded(notifications.data));
             }

            //set in Redux state the access token
            yield put(loginSucceeded(response.data));
            yield put(push(ROOT_ROUTE))
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* registerSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(register, action.payload);

        if (response.status === 200) {
            yield put(hideSpinner());
            yield put(registerSucceeded(response.data));
            yield put(registerApiMessagesShow(response.data));
            yield put(push(LOGIN_ROUTE));
        }
    } catch (e) {
        yield put(hideSpinner());
        if( e.message.substr(e.message.length - 3) === '400') {
            yield put(showGeneralError(USER_ALREADY_EXISTS));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }

    }
}

function* refreshTokenSaga(action) {
    try {
        const response = yield call(refreshTokenLogin, action.payload);
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('login_type', response.data.user_roles[0]);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        localStorage.setItem('user_id', response.data.user_id);
        localStorage.setItem('cinema_location', "Bucuresti");
        let today = new Date();
        today.setSeconds(today.getSeconds() + response.data.expires_in);
        let datePlus = today.getTime();
        localStorage.setItem('expires_in', datePlus);

        yield put(loginSucceeded(response.data));

    } catch (e) {
        localStorage.clear();
        yield put(requestLoginGuest);
        yield put(push(LOGIN_ROUTE));
    }
}

function* sendTemporaryPasswordSaga(action) {
    try {
        yield call(sendTemporaryPassword, action.payload);
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* resetPasswordSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(resetPassword, action.payload);
        if(response.status === 200){
            yield put(hideSpinner());
            yield put(push(LOGIN_ROUTE))
        }
    } catch (e) {
        if( e.message.substr(e.message.length - 3) === '400') {
            yield put(loginApiMessagesShow({error: WRONG_TEMPORARY_PASSWORD}));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    }
}

function* changePasswordSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(changePassword, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if( response.status === 200) {
            window.localStorage.clear();
            yield put(push(LOGIN_ROUTE));
            yield put(showGeneralError(CHANGE_PASSWORD_SUCCEEDED_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    } catch (e) {
        yield put(hideSpinner());
        if( e.message.substr(e.message.length - 3) === '422') {
            yield put(loginApiMessagesShow({error: WRONG_PASSWORD}));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }

    }
}

export default function* userSaga() {
    yield takeLatest(REQUEST_LOGIN, loginSaga);
    yield takeLatest(REQUEST_REGISTER, registerSaga);
    yield takeLatest(REQUEST_LOGIN_GUEST, loginGuestSaga);
    yield takeLatest(LOGIN_API_FACEBOOK, loginFacebookSaga);
    yield takeLatest(LOGIN_API_GOOGLE, loginGoogleSaga);
    yield takeLatest(REFRESH_TOKEN_AUTH, refreshTokenSaga);
    yield takeLatest(SEND_TEMPORARY_PASSWORD, sendTemporaryPasswordSaga);
    yield takeLatest(RESET_PASSWORD, resetPasswordSaga);
    yield takeLatest(CHANGE_PASSWORD, changePasswordSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/user.saga.js